/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getSalesOrderTrackingNumberAsync } from './DataActionExtension.g';

/**
 * GetOrderTrackingCode Input Action
 */
export class GetOrderTrackingCodeInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public salesId: string;
    constructor(salesId: string) {
        this.salesId = salesId;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `SALESID:${this.salesId}`;
    public getCacheObjectType = () => 'TRACKINGCODE';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const salesId = args.requestContext.url.requestUrl.searchParams.get('salesId');
    return new GetOrderTrackingCodeInput(salesId || '');
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetOrderTrackingCodeInput, ctx: Msdyn365.IActionContext): Promise<string> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    const { salesId } = input;
    console.log(salesId);
    if (!salesId) {
        return '';
    }
    const d = await getSalesOrderTrackingNumberAsync({ callerContext: ctx }, salesId);
    console.log(d);
    return d?.TrackingNumber || '';
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<string>>action,
    // TODO: Give your data action a unique id
    id: 'GetOrderTrackingCode',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
